exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-base-ticket[data-v-38b66cd2]{-webkit-transition:all .45s ease;transition:all .45s ease;will-change:transform;-webkit-transform:translateY(calc(100% + .5rem));transform:translateY(calc(100% + .5rem));max-width:440px;max-height:700px;opacity:1}.ps-base-ticket.ps-is-active[data-v-38b66cd2]{-webkit-transform:translateY(0);transform:translateY(0)}.ps-base-ticket.ps-is-minimized[data-v-38b66cd2]{-webkit-transform:translateY(calc(100% - 6rem));transform:translateY(calc(100% - 6rem))}", ""]);

// exports
